import { Controller } from "@hotwired/stimulus"
import { post } from "../lib/http"
import { burstConfetti } from "../lib/confetti"

// Discovery feed card. Tapping "Reveal" flips the card to its revealed look right
// in the feed (both photos, with a reveal animation) and marks the current user
// revealed server-side — no navigation. "View match" then opens the detail page.
export default class extends Controller {
  static targets = ["unrevealed", "revealed", "revealButton", "revealHint", "viewMatch", "revealBadge"]
  static values = { revealUrl: String }

  reveal() {
    if (this.hasUnrevealedTarget) this.unrevealedTarget.style.display = "none"
    if (this.hasRevealedTarget) {
      this.revealedTarget.style.display = "block"
      this.revealedTarget.classList.add("card-reveal-anim")
    }
    this.hideRevealBadges()
    if (this.revealUrlValue) post(this.revealUrlValue).catch(() => {})
  }

  // "Reveal my photo" = approve my photo so the other person can see it (their
  // photo stays blurred to me until THEY approve). Posts the reveal, then replaces
  // the reveal button + hint with the "View match" button in place.
  approve() {
    burstConfetti(this.element)  // burst across the whole card, not just the button
    if (this.revealUrlValue) post(this.revealUrlValue).catch(() => {})
    if (this.hasRevealButtonTarget) this.revealButtonTarget.style.display = "none"
    if (this.hasRevealHintTarget) this.revealHintTarget.style.display = "none"
    if (this.hasViewMatchTarget) this.viewMatchTarget.style.display = "block"
    this.hideRevealBadges()
  }

  // Drop the "Not revealed yet" badge on my own photo the moment I reveal (both
  // entry points post the reveal). No-op where there's no badge (e.g. groups,
  // which clear it via a server broadcast instead).
  hideRevealBadges() {
    this.revealBadgeTargets.forEach((el) => { el.style.display = "none" })
  }
}
